import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import {AlertTitle} from '@chakra-ui/react';

import {AlertIcon} from '@amblique/king-living/app/components/icons';
import {ProductDetail as ProductDetailComponent} from '@amblique/king-living/app/components/product-detail';
import {usePageContext} from '@amblique/king-living/app/hooks/contentful';
import {usePixleeScript} from '@amblique/king-living/app/hooks/use-pixlee-script';
import Alert from '@amblique/king-living/app/theme/components/base/alert';

/**
 * ProductDetail component
 *
 * @param {Object} props - Component props
 * @param {Contentful.ProductDetail} props.component - ProductDetail component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const ProductDetail = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {
    isEdit,
    isProductPage,

    product,
    isProductLoading,
    isProductError,
    productError,
  } = usePageContext();

  // Load Pixlee script for UGC widgets on product pages
  usePixleeScript();

  return (
    isProductPage ? (
      <ProductDetailComponent
        isProductError={isProductError}
        isProductLoading={isProductLoading}
        product={product}
        productError={productError}
      />
    ) : isEdit ? (
      <Alert status="warning">
        <AlertIcon />
        <AlertTitle>Product Detail - Dynamic</AlertTitle>

        <FormattedMessage
          defaultMessage="This component can only be added to '{aspectType}' pages."
          id="contentful.error.invalid_aspects"
          values={{aspectType: 'Product Detail'}}
        />
      </Alert>
    ) : null
  );
};

ProductDetail.displayName = 'ProductDetail';
ProductDetail.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
